import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Breadcrumb } from '@navfleet/client/shell/domain/models';
import { TranslationModule } from '@navfleet/shared/core/translation';
import { ProgressSpinner } from '@openng/optimus-ui/progressspinner';

@Component({
    imports: [TranslationModule, RouterLink, ProgressSpinner],
    selector: 'fl-top-menu-breadcrumbs',
    templateUrl: './top-menu-breadcrumbs.component.html',
    styleUrls: ['./top-menu-breadcrumbs.component.scss'],
})
export class TopMenuBreadcrumbsComponent {
    public readonly breadcrumbs = input<Breadcrumb[]>([]);
}
